import { html } from "lit-element";
import { DrawSVGBaseModule } from "../../ModuleBase/svg-base-module";

export class DrawBlueModule extends DrawSVGBaseModule {
	constructor(canvas) {
		super(canvas);

		this.name = "blue";
		this.icon = svg_blue;
	}
}

window.customElements.define("inspx-draw-blue-module", DrawBlueModule);

const svg_blue = html`
<svg
xmlns:svg="http://www.w3.org/2000/svg"
xmlns="http://www.w3.org/2000/svg"
width="18.040855mm"
height="7.829649mm"
viewBox="0 0 18.040855 7.829649"
version="1.1"
id="svg2601"
>
<g
  transform="translate(-80.937908,-157.7697)">
 <rect
    style="fill:#0026ff;fill-opacity:0.97340423;stroke:#000000;stroke-width:0.22846262;stroke-miterlimit:0;stroke-dasharray:none;stroke-opacity:1"
    id="rect4062"
    width="17.812393"
    height="7.6011863"
    x="81.052139"
    y="157.88393"
    ry="2.89569" />
</g>
</svg>
`;
